<template>
    <div class="hos-form">
        <div class="sub_title fb"><img src="../../assets/icon/Rectangle2.png" class="mr10 imgb">请选择号源时段</div>
        <div class="mt10">
            <div class="flex mt10 jc pt5 pb5 pl10 pr10 bg_fff warp" style="min-height: 250px">
                <span class="flex width20 pointer pt5 pl5 pb5 pr5 h40 just mar" :class="{bg_pra:item.numno==numno}" v-for="item in list" :key="item.deptId" @click="saveNum(item)">{{item.numno}}号 &nbsp;&nbsp; {{item.numtime}}</span>
            </div>
            <div class="flex jce mt20">
                <el-button type="primary" size="medium" @click="hrefRoute">下一步</el-button>
            </div>
        </div>
    </div>
</template>

<script>
  import {orderTime} from "../../lib/cache/OrderTime";

  export default {
    name: "Num",
    props: {
      list: {
        type: Array,
        default: ()=>{
          return []
        }
      },
        title: {
            type: Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
      return {
        numno: '',
          clickFlag: false
      }
    },
    watch: {
      id(newV) {
        this.$emit('input', newV);
      }
    },
    methods:{
      saveNum(a){
          this.clickFlag = true;
        this.numno = a.numno
        const ot = orderTime.get()
        ot.numno = a.numno
        ot.numtime = a.numtime
        ot.numid = a.numid
        orderTime.set(ot)
      },
        hrefRoute(){
          if(this.clickFlag){
              this.$router.push({path:'/main/registration/check',query:{title:this.title}})
          }else{
              this.$message.error('请选择号源！');
          }
        }
    }
  }
</script>

<style scoped lang="scss">
    @import "../../styles/var";
    .hos-form{
        margin-top: 20px;
        padding: 10px 20px;
        color: #666666;
        span+span{
            margin-right: 10px;
            cursor: pointer;
        }
    }
    .sub_title{
        padding: 5px 0px;
        color: #1E1E1E;
    }
    .bg_pra{
        background: #3692F9;
        border-radius: 1px;
        color: #FFFFFF;
    }
    .h40{
        height: 40px;
    }
    .imgb{
        vertical-align: bottom;
    }
    .fb{
        font-weight: bold;
    }

    .just{
        justify-content:center;
        align-items: center;
    }
    .mar{
        margin-right: 0 !important;
    }

    .warp{
        flex-wrap: wrap;
    }
</style>
